import React from 'react'
import { Button, Table } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'
import { MsProjectPreview } from '@/Services/MsProjectImportService'
import TaskImportSourceViewer from '@/Components/TaskImportSourceViewer/TaskImportSourceViewer'
import { ProgrammingRow } from './types'

type Props = {
  errorTaskUids: Set<string>
  highlightedUid: string | null
  preview: MsProjectPreview
  rows: ProgrammingRow[]
  onExcludeTask: (uid: string) => void
  onUpdateTaskDate: (uid: string, field: 'start' | 'finish', value: string) => void
  onUpdateTaskId: (uid: string, value: string) => void
  onUpdateTaskName: (uid: string, name: string) => void
  onGoToColorCode: (id: string) => void
}

const ProgrammingTab = ({ errorTaskUids, highlightedUid, preview, rows, onExcludeTask, onUpdateTaskDate, onUpdateTaskId, onUpdateTaskName, onGoToColorCode }: Props) => {
  const { t } = useTranslation()

  if (!rows.length) return <div className="text-muted py-3">{t('MS_PROJECT_IMPORTER:NoProgramming')}</div>

  return (
    <>
      <h5>{t('MS_PROJECT_IMPORTER:ProgrammingPreview')}</h5>
      <Table bordered size="sm" responsive className="ms-project-importer-programming">
        <thead><tr><th>{t('TASK_IMPORTER:IdColumn')}</th><th>{t('TASK_IMPORTER:TitleColumn')}</th><th>{t('TASK_IMPORTER:StartsAtColumn')}</th><th>{t('TASK_IMPORTER:EndsAtColumn')}</th>{preview.sourceType === 'gantt' && <th>{t('MS_PROJECT_IMPORTER:ColorCode')}</th>}<th>%</th><th>{t('MS_PROJECT_IMPORTER:Actions')}</th><th>{t('TASK_IMPORT_SOURCE:Column')}</th></tr></thead>
        <tbody>{rows.map(row => {
          const hasError = errorTaskUids.has(row.uid) || (row.type !== 'group' && (!row.start || (!row.finish && row.type !== 'hito' && row.type !== 'reunion')))
          return (
            <tr key={`${row.type}-${row.uid}`} data-programming-uid={row.uid} className={[ hasError ? 'ms-project-importer-error-row' : '', highlightedUid === row.uid ? 'ms-project-importer-highlighted-row' : '' ].filter(Boolean).join(' ') || undefined}>
              <td>{preview.sourceType === 'gantt' || preview.sourceType === 'pull_planning'
                ? <input className="form-control form-control-sm ms-project-importer-id-input" type="text" value={row.id} aria-label={`${t('TASK_IMPORTER:IdColumn')} ${row.name}`} onChange={event => onUpdateTaskId(row.uid, event.target.value)} />
                : row.id}</td>
              <td>{row.type === 'group' ? <strong>{row.name}</strong> : hasError ? <input className="form-control form-control-sm" type="text" value={row.name} aria-label={t('MS_PROJECT_IMPORTER:TaskName')} onChange={event => onUpdateTaskName(row.uid, event.target.value)} /> : row.name}</td>
              <td>{row.type === 'group' ? '-' : <input className="form-control form-control-sm" type="date" value={row.start || ''} min={preview.project.startsAt || undefined} max={preview.project.endsAt || undefined} onChange={event => onUpdateTaskDate(row.uid, 'start', event.target.value)} />}</td>
              <td>{row.type === 'group' || row.type === 'hito' || row.type === 'reunion' ? '-' : <input className="form-control form-control-sm" type="date" value={row.finish || ''} min={preview.project.startsAt || undefined} max={preview.project.endsAt || undefined} onChange={event => onUpdateTaskDate(row.uid, 'finish', event.target.value)} />}</td>
              {preview.sourceType === 'gantt' && <td>{row.colorCodeId ? (() => { const code = preview.colorCodes?.find(item => item.id === row.colorCodeId); return code ? <button type="button" className="ms-project-importer-task-link ms-project-importer-color-link" onClick={() => onGoToColorCode(code.id)}><span style={{ backgroundColor: code.color }} />{code.name}</button> : '-' })() : '-'}</td>}
              <td>{row.percentComplete === null ? '-' : row.percentComplete}</td>
              <td>{row.type === 'group' ? '-' : <Button size="sm" variant="outline-danger" onClick={() => onExcludeTask(row.uid)}>{t('MS_PROJECT_IMPORTER:ExcludeTask')}</Button>}</td>
              <td><TaskImportSourceViewer source={row.importSource} taskName={row.name} compact /></td>
            </tr>
          )
        })}</tbody>
      </Table>
    </>
  )
}

export default ProgrammingTab
